import { Optional, Record, String, Unknown } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type AuthenticationProps = {
  props: {
    redirectOrigin: string
    signUpPath?: string
    recoverPasswordPath?: string
    styleMap?: StyleMap
  }
}

export const AuthenticationTypeGuard = Record({
  redirectOrigin: String,
  signUpPath: Optional(String),
  recoverPasswordPath: Optional(String),
  styleMap: Optional(Unknown)
})
